import Loadable from "@loadable/component"

export const SpecialBook = Loadable(() => import("./you-are-special/you-are-special.js"))
export const FlowVis = Loadable(() => import("./flow-vis/flow-vis.js"))
